import React, { useEffect, useState } from "react";
import "./Topbar.css";
import { useGeneralSetting } from "../context/GeneralSettingContext";

const Topbar = () => {
  const { generalSetting } = useGeneralSetting();
  const [isLangOpen, setIsLangOpen] = useState(false);
  const [currentLang, setCurrentLang] = useState("EN");

  useEffect(() => {
    const interval = setInterval(() => {
      const select = document.querySelector(".goog-te-combo");
      if (select) clearInterval(interval);
    }, 500);
    return () => clearInterval(interval);
  }, []);

  const handleLanguageChange = (lang) => {
    const select = document.querySelector(".goog-te-combo");
    if (select) {
      select.value = lang;
      select.dispatchEvent(new Event("change"));
    }
    setCurrentLang(lang.toUpperCase());
    setIsLangOpen(false);
  };

  return (
    <header className="lh-tbar-master-wrapper">
      {/* Hidden Google Translate Hook */}
      <div id="google_translate_element" style={{ display: "none" }} />

      <div className="lh-tbar-main-flex">
        {/* Left: Language Selector */}
        <div className="lh-tbar-lang-wrapper">
          <button
            className="lh-tbar-lang-btn"
            onClick={() => setIsLangOpen(!isLangOpen)}
          >
            🌐 <span>{currentLang}</span> <small>▼</small>
          </button>

          {isLangOpen && (
            <ul className="lh-tbar-lang-dropdown">
              <li
                className="lh-tbar-lang-item"
                onClick={() => handleLanguageChange("en")}
              >
                <span className="lh-tbar-country-tag">US</span> English
              </li>
              <li
                className="lh-tbar-lang-item"
                onClick={() => handleLanguageChange("hi")}
              >
                <span className="lh-tbar-country-tag">IN</span> हिन्दी
              </li>
              <li
                className="lh-tbar-lang-item"
                onClick={() => handleLanguageChange("gu")}
              >
                <span className="lh-tbar-country-tag">IN</span> ગુજરાતી
              </li>
            </ul>
          )}
        </div>

        {/* Middle: Ticker */}
        <div className="lh-tbar-ticker-box">
          <div className="lh-tbar-ticker-track">
            <span>🚀 Special Offer: 0% Processing Fee on Home Loans!</span>
            <span>💰 Instant Approval for Personal Loans</span>
            <span>📞 Contact us for Expert Financial Advice</span>
            {/* Duplicate for seamless loop */}
            <span>🚀 Special Offer: 0% Processing Fee on Home Loans!</span>
            <span>💰 Instant Approval for Personal Loans</span>
          </div>
        </div>

        {/* Right: Contact Info */}
        <div className="lh-tbar-contact-group">
          <a
            href={`https://wa.me/${generalSetting?.contact_number || "9909002220"}?text=Hello, I would like to know more about your services.`}
            target="_blank"
            rel="noopener noreferrer"
            className="lh-tbar-link"
          >
            📞{" "}
            <span className="lh-tbar-nav-text">
              +91 {generalSetting?.contact_number || "9909002220"}
            </span>
          </a>

          <div className="lh-tbar-divider"></div>

          <a
            href={`mailto:${generalSetting?.email || "info@loan-house.com"}`}
            className="lh-tbar-link"
          >
            ✉️{" "}
            <span
              className="lh-tbar-nav-text"
              style={{ textTransform: "lowercase" }}
            >
              {generalSetting?.email || "info@loan-house.com"}
            </span>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Topbar;
